import React, { useEffect, useState } from "react";
import { Table, Pagination } from "react-bootstrap";
import {
  FiPlus,
  FiHome,
  FiChevronRight,
  FiEdit,
} from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getstandardfees } from "../../store/slices/fees";
import { toast } from "react-hot-toast";

export default function FeeStructure() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [feeCategories, setFeeCategories] = useState([]);

  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const fetchFeeCategories = () => {
    dispatch(getstandardfees())
      .unwrap()
      .then((res) => {
        const data = res?.data || [];
        setFeeCategories(data);
        setTotalData(data.length);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to fetch fee categories");
        setFeeCategories([]);
      });
  };

  useEffect(() => {
    fetchFeeCategories();
  }, []);

  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const paginatedData = feeCategories.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>

            <FiChevronRight className="separator" />

            <span className="active">Fee Structure</span>
          </div>

          <Link
            to="/institute/add-fee-structure"
            className="add-btn"
          >
            <FiPlus />
            Add Fee Structure
          </Link>
        </div>
      </div>

      <div className="staff-card">
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th className="text-center">Session</th>
                <th className="text-center">Standard</th>
                <th className="text-center">Fee Categories</th>
                <th className="text-center">Total Amount</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">
                    No fee structures found
                  </td>
                </tr>
              ) : (
                paginatedData.map((item, index) => {
                  const totalAmount = item.feeDetails.reduce(
                    (sum, fee) => sum + fee.amount,
                    0
                  );

                  return (
                    <tr key={item._id}>
                      <td className="text-center">
                        {startIndex + index + 1}
                      </td>

                      <td className="text-center">
                        {item.session}
                      </td>

                      <td className="text-center">
                        {item.standardId?.name}
                      </td>
                      <td>
                        {item.feeDetails.map((fee) => (
                          <div
                            key={fee._id}
                            className="mb-3 pb-2"
                          >

                            {fee.paymentBreakdown.map((term) => (
                              <div
                                key={term._id}
                                className="d-flex justify-content-between ms-3"
                              >
                                <span>{term.name}</span>

                                <span>
                                  ₹{term.amount.toLocaleString()} (
                                  {new Date(term.dueDate).toLocaleDateString("en-GB")})
                                </span>
                              </div>
                            ))}
                          </div>
                        ))}
                      </td>
                      <td className="text-center">
                        ₹{totalAmount.toLocaleString()}
                      </td>

                      <td className="text-center">
                        <button
                          className="edit-btn"
                          onClick={() =>
                            navigate(`/institute/edit-fee-structure/${item._id}`)
                          }
                        >
                          <FiEdit size={16} />
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 &&
                  page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              if (page === currentPage - 2) {
                return (
                  <Pagination.Ellipsis
                    key={`left-${page}`}
                    disabled
                  />
                );
              }

              if (page === currentPage + 2) {
                return (
                  <Pagination.Ellipsis
                    key={`right-${page}`}
                    disabled
                  />
                );
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />
          </Pagination>
        </div>
      </div>
    </>
  );
}